import { Die } from "../models/messages";

export const DICE: Array<Die> = ["d20", "d12", "d10", "d8", "d6", "d4"];
